import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _890686a0 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _11d19128 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _388cfb4b = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _3ce68d1a = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _00e9f613 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _056db1fa = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _01022481 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _0b4f011c = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _f44758b6 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _3c611ec6 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _0276c1cc = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _43f0aa94 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _3e451193 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _439701cb = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _198d47f6 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _424a695d = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _1178b653 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _714e98b0 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _6ec7f9f0 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _414f6c06 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _9eba1d82 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _3a4d06b3 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _4120c3da = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _984603c0 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _4e693df6 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _e40a904a = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _3258df79 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _2e19e28f = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _719a4e74 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _020c3a87 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _75ff803c = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _ef16e8cc = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _80332c48 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _07173c88 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _25c3f1ba = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _ad16df0a = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _35b7e03a = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _561e91ad = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _f19487a6 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _d75bfa0e = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _e3c01ab4 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _2be08972 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _5f6f3e8a = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0ad27896 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _544b3040 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _27e7fb5a = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _14fcdae2 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _4e83e35c = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _d6b63b4e = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _68ae77a1 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _27ee38c4 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _48fa6090 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _061487c3 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _08953828 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _98b0d70a = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _49b4d804 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _14455fe1 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _0a00c94c = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _cf4e3da0 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _9e0a15fa = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _1200d2ca = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _0704ac82 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _45b9764b = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _c11ba9d0 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _95b1571a = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _c9e11b22 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _b6d73d8a = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _1344fb4d = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _1143a002 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _b66dfea8 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _2b0ffc00 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _2fe78b6e = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _199953ca = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _24663ac4 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _890686a0,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _11d19128,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _388cfb4b,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _3ce68d1a,
    name: "calendar"
  }, {
    path: "/customer",
    component: _00e9f613,
    name: "customer"
  }, {
    path: "/details",
    component: _056db1fa,
    name: "details"
  }, {
    path: "/goals",
    component: _01022481,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _0b4f011c,
    name: "maisoku"
  }, {
    path: "/media",
    component: _f44758b6,
    name: "media"
  }, {
    path: "/privacy",
    component: _3c611ec6,
    name: "privacy"
  }, {
    path: "/project",
    component: _0276c1cc,
    name: "project"
  }, {
    path: "/response",
    component: _43f0aa94,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _3e451193,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _439701cb,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _198d47f6,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _424a695d,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _1178b653,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _714e98b0,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _6ec7f9f0,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _414f6c06,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _9eba1d82,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _3a4d06b3,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _4120c3da,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _984603c0,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _4e693df6,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _e40a904a,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _3258df79,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _2e19e28f,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _719a4e74,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _020c3a87,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _75ff803c,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _ef16e8cc,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _80332c48,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _07173c88,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _25c3f1ba,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _ad16df0a,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _35b7e03a,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _561e91ad,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _f19487a6,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _d75bfa0e,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _e3c01ab4,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _2be08972,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _5f6f3e8a,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0ad27896,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _544b3040,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _27e7fb5a,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _14fcdae2,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _4e83e35c,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _d6b63b4e,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _68ae77a1,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _27ee38c4,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _48fa6090,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _061487c3,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _08953828,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _98b0d70a,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _49b4d804,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _14455fe1,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _0a00c94c,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _cf4e3da0,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _9e0a15fa,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _1200d2ca,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _0704ac82,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _45b9764b,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _c11ba9d0,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _95b1571a,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _c9e11b22,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _b6d73d8a,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _1344fb4d,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _1143a002,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _b66dfea8,
    name: "property-property",
    children: [{
      path: "contact",
      component: _2b0ffc00,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _2fe78b6e,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _199953ca,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _24663ac4,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
